import { render, staticRenderFns } from "./SameDayShippingCountdown.vue?vue&type=template&id=f801aa0a&scoped=true&"
import script from "./SameDayShippingCountdown.vue?vue&type=script&lang=ts&"
export * from "./SameDayShippingCountdown.vue?vue&type=script&lang=ts&"
import style0 from "./SameDayShippingCountdown.vue?vue&type=style&index=0&id=f801aa0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f801aa0a",
  null
  
)

export default component.exports